// extracted by mini-css-extract-plugin
module.exports = {"cardDescription":"EvoMlInference_cardDescription___MWZz"};